import { Inject, Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { Database, DatabaseReference, equalTo, listVal, object, objectVal, orderByChild, query, ref, update } from '@angular/fire/database';
import { CFGRequest } from '@lfg-interface/requests.interfaces';
import { BehaviorSubject, Observable, Subject, catchError, map, take } from 'rxjs';
import { User } from '@angular/fire/auth';
import { Provider } from '@lfg-interface/provider.interfaces';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LeadService {

  private socket: WebSocket | null = null;
  private watchId: number | null = null;
  private isTrackingSubject = new BehaviorSubject<boolean>(false);
  public isTracking$ = this.isTrackingSubject.asObservable();

  DATABASE_PATH: string = 'CarFinderGeniePlatform/requests/';
  CUSTOMERS_PATH: string = 'CarFinderGeniePlatform/customers';

  constructor(
              private DATABASE: Database,
              private httpClient: HttpClient
              ) { }

  public getLeadsByRequestType(requestType: string): Observable<CFGRequest[]> {
    const DATABASE_REFERENCE: DatabaseReference = ref(this.DATABASE, `${this.DATABASE_PATH}`);
    return objectVal(DATABASE_REFERENCE);
  }

  public getCustomerData(uid: string): Observable<any> {
    const DATABASE_REFERENCE: DatabaseReference = ref(this.DATABASE, `${this.CUSTOMERS_PATH}/${uid}/`);
    return objectVal(DATABASE_REFERENCE);
  }

  public getCustomersDeviceId(): Observable<any[]> {
    const DATABASE_REFERENCE: DatabaseReference = ref(this.DATABASE, `CarFinderGeniePlatform/customers_device_id/`);
    return listVal(DATABASE_REFERENCE);
  }

  /**
   * Obtener el índice actual del round robin de correos desde Realtime Database
   */
  public getNextEmailRoundRobinIndex(): Observable<number | null> {
    const META_REFERENCE: DatabaseReference = ref(this.DATABASE, `_meta/emailRoundRobin/`);
    return objectVal<any>(META_REFERENCE).pipe(
      take(1),
      map((data: any) => {
        if (!data || typeof data.nextIndex !== 'number') {
          return null;
        }
        return data.nextIndex as number;
      })
    );
  }

  public async updateLeadStatus(lead_id: string, uid: string): Promise<void> {
    return new Promise(async (resolve, reject) => {
      const DATABASE_REFERENCE: DatabaseReference = ref(this.DATABASE, `${this.DATABASE_PATH}${lead_id}/sellers_uid/${uid}`);
      update(DATABASE_REFERENCE, {
        status: 'readed'
      }).then(() => {
        resolve();
      }).catch((error: firebase.default.FirebaseError) => {
        reject(error);
      });
    });
  }

  public getRequest(lead_id: string): Observable<any> {
    const DATABASE_REFERENCE: DatabaseReference = ref(this.DATABASE, `${this.DATABASE_PATH}/${lead_id}`);
    return objectVal<any>(DATABASE_REFERENCE);
  }

  public setLeadStatus(id: string, status: string, uid: string): Promise<void> {
    return new Promise(async (resolve, reject) => {
      const DATABASE_REFERENCE: DatabaseReference = ref(this.DATABASE, `${this.DATABASE_PATH}${id}/sellers_uid/${uid}`);
      update(DATABASE_REFERENCE, {
        request_status: status
      }).then(() => {
        resolve();
      }).catch((error: firebase.default.FirebaseError) => {
        reject(error);
      });
    });
  }

  public updateFinancialStatus(id: string, status: string): Promise<void> {
    return new Promise(async (resolve, reject) => {
      const DATABASE_REFERENCE: DatabaseReference = ref(this.DATABASE, `${this.DATABASE_PATH}${id}`);
      update(DATABASE_REFERENCE, {
        financial_status: status
      }).then(() => {
        resolve();
      }).catch((error: firebase.default.FirebaseError) => {
        reject(error);
      });
    });
  }

  /**
   * Crear y registrar un nuevo lead a través de Cloud Function
   */
  public async saveNewRequest(request: CFGRequest): Promise<string | null> {
    return new Promise(async (resolve, reject) => {
      const PAYLOAD_AS_TEXT: string = JSON.stringify(request);
      this.httpClient.post(`${environment.cloud_functions_urls.createAndRegisterLead}`, PAYLOAD_AS_TEXT).pipe(
        catchError((errorTest: HttpErrorResponse): any => {
          if (errorTest.error instanceof ErrorEvent) {
            reject(errorTest.error);
          } else {
            reject(errorTest);
          }
        })
      ).subscribe(
        ($response: any) => {
          resolve($response.key);
        },
        (error: any) => {
          reject(error);
        },
        () => {}
      );
    });
  }


}
